import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { observable, action, autorun, extendObservable, computed } from 'mobx';
import Modal from '../../Modal';
import Form, { FormBody, FormActions, TextInput, SelectInput, DateInput, SwitchInput } from '../../Form';
import { toJS } from "mobx/lib/mobx";
import moment from 'moment';
import IntervalInput from '../../Form/IntervalInput';
import Spinner from '../../Spinner';
import _ from 'lodash';

@inject('stationStore', 'parameterStore', 'unitStore', 'aggregationStore')
@observer
class StationDataSeriesEdit extends Component {
  static contextTypes = {
    router: PropTypes.shape().isRequired,
    notify: PropTypes.shape().isRequired,
  };

  static propTypes = {
    route: PropTypes.shape().isRequired,
    params: PropTypes.shape({
      id: PropTypes.string,
    }).isRequired,
  };

  @observable stationDataSeries = {
    start_time: '00:00',
    tolerance: 0,
    parameter: {},
    name: '',
    parameter_id: '',
    parameter_unit_id: '',
    interval: '',
    table: null
  };
  @observable aggregation = {
    aggregation_method_id: null,
    source_series_id: null,
    out_series_id: null,
    interval_id: null,
    use_suspicious: true,
    starting_time: '00:00',
    max_cons_missing_values: null,
    max_missing_values: null,
    timestamp: '',
    enabled: true,
    aggregation_type: 1,
    time_offset: 0
  };
  @observable dataSeriesItem;
  @observable parameterItems;
  @observable tab = 0;
  @observable isLoading = false;
  disposer;

  slug;
  title = 'Edit Primary Series';

  dataSearchTable = [
    { id: 0, name: 'Primary Data' },
    { id: 1, name: 'Secondary Data' }
  ];

  constructor(props) {
    super(props);

    this.reset();
    this.handleSave = this.handleSave.bind(this);
  }

  componentWillMount() {
    const {
      params: { id, dataSeriesId },
      stationStore,
      parameterStore,
      unitStore, aggregationStore
    } = this.props;

    if (!aggregationStore.aggregationMethods.length) aggregationStore.fetchAggregationMethods();
    if (!aggregationStore.intervals.length) aggregationStore.fetchIntervals();
    if (!unitStore.isLoading && !unitStore.items.length) unitStore.fetchItems();

    this.disposer = autorun(() => {
      this.isLoading = true;
      parameterStore.fetchItems()
        .then(action(parameters => {
          this.resetParameters(parameters);
          return stationStore.fetchDataSeriesItem(id, dataSeriesId);
        }))
        .then(action(dataSeries => {
          if (!dataSeries.table) dataSeries.table = 0;
          this.resetDataSeriesItem(dataSeries);
          this.isLoading = false;
        }));
    });

    stationStore.fetchDataSeries(id)
      .then(dataSeriesItems => {
        this.dataSeriesItems = dataSeriesItems
      });
  }

  componentWillUnmount() {
    this.disposer();
  }

  @action reset() {
    const { params: { id } } = this.props;

    this.parameterItems = [];
    this.slug = `/station/${id}/data-series`;
  }

  @action resetParameters(parameterItems) {
    this.parameterItems = parameterItems;
  }

  @action resetDataSeriesItem(dataSeriesItem) {
    const parameter = this.parameterItems.find(item => +item.id === +dataSeriesItem.parameter_id);
    if (dataSeriesItem.table === 1 && !!dataSeriesItem.aggregation) {
      this.aggregation = extendObservable(this.aggregation, dataSeriesItem.aggregation || {}, {
        timestamp: (_.get(dataSeriesItem, 'aggregation.timestamp', '')).split('+')[0].split('.')[0],
        aggregation_type: _.get(dataSeriesItem, 'aggregation.aggregation_type', 1),
        time_offset: _.get(dataSeriesItem, 'aggregation.time_offset', 0),
        use_suspicious: _.get(dataSeriesItem, 'aggregation.use_suspicious', 0),
      });
      delete dataSeriesItem.aggregation;
    }
    this.stationDataSeries = extendObservable(this.stationDataSeries, dataSeriesItem, { parameter });

  }

  @action onChangeUnit = (e) => this.stationDataSeries.parameter_unit_id = e.target.value;
  @action onChangeName = (e) => this.stationDataSeries.name = e.target.value;
  @action onChangeParameter = (e) => {
    const parameterId = e.target.value;
    this.stationDataSeries.parameter_id = parameterId;
    const parameter = this.parameterItems.find(item => +item.id === +parameterId);
    this.stationDataSeries.parameter = parameter;
    this.stationDataSeries.parameter_unit_id = parameter && parameter.parameter_unit_id;
  }
  @action onChangeInterval = (e) => this.stationDataSeries.interval = e.target.value;
  @action onChangeStartTime = (e) => {
    this.stationDataSeries.start_time = e.target.value;
    this.aggregation.starting_time = e.target.value;
  }
  @action onChangeTolerance = (e) => this.stationDataSeries.tolerance = e.target.value;
  @action onChangeTable = e => {
    this.stationDataSeries.table = e.target.value;
    this.tab = e.target.value;
  }

  @action onChangeAggregationMethod = e => this.aggregation.aggregation_method_id = +e.target.value;
  @action onChangeSourceDataSeries = e => this.aggregation.source_series_id = +e.target.value;
  @action onChangeUseSuspicious = e => this.aggregation.use_suspicious = ~this.aggregation.use_suspicious + 2;
  @action onChangeEnabled = e => this.aggregation.enabled = !this.aggregation.enabled;
  @action onChangeTimestamp = e => this.aggregation.timestamp = moment(e.target.value).format('YYYY-MM-DDTHH:mm:ss');
  @action onChangeAggregationType = e => this.aggregation.aggregation_type = e.target.value;
  @action onChangeAggregationInterval = e => this.aggregation.interval_id = e.target.value;
  @action onChangeMaxConsMissingValues = e => this.aggregation.max_cons_missing_values = e.target.value;
  @action onChangeMaxMissingValues = e => this.aggregation.max_missing_values = e.target.value;
  @action onChangeTimeOffset = e => this.aggregation.time_offset = e.target.value;


  @action handleSave(e) {
    e.preventDefault();

    const { params: { id, dataSeriesId }, stationStore } = this.props;
    const { notify } = this.context;
    let payload = Object.assign({}, this.stationDataSeries);

    let aggregationPayload = Object.assign({}, toJS(this.aggregation));

    let apiPost = this.stationDataSeries.table === 0 ?
      stationStore.updateDataSeriesItem(id, dataSeriesId, payload) :
      stationStore.updateAggregatedDataSeriesItem(id, dataSeriesId, payload, toJS(this.aggregation));

    apiPost
      .then(() => {
        this.context.router.push(this.slug);
        notify.success({ message: 'Updated Station Data Series' });
      })
      .catch(action((err) => { notify.error(err); }));
  }

  @computed get unit() {
    return this.stationDataSeries.parameter_unit_name ?
      `${this.stationDataSeries.parameter_unit_name} (${this.stationDataSeries.parameter_unit_symbol})` : '';
  }

  renderAggregationFields = () => {
    const { aggregationStore } = this.props;
    if (this.aggregation.aggregation_method_id === 5) {
      return (
        <div>
          <SelectInput
            label={'Aggregation Method'}
            fields={{ label: 'description', value: 'id' }}
            options={aggregationStore.aggregationMethods}
            onChange={this.onChangeAggregationMethod}
            value={this.aggregation.aggregation_method_id}
          />
          <SelectInput
            label={'Source Data Series'}
            fields={{ label: 'name', value: 'id' }}
            options={this.dataSeriesItems}
            value={this.aggregation.source_series_id}
            onChange={this.onChangeSourceDataSeries}
          />
          <DateInput label='Datetime' type='datetime-local' value={this.aggregation.timestamp} onChange={this.onChangeTimestamp} />
          <SwitchInput label='Use Suspicious' value={!!this.aggregation.use_suspicious} onChange={this.onChangeUseSuspicious} />
          <SwitchInput label='Enable Automatic' value={!!this.aggregation.enabled} onChange={() => this.aggregation.enabled = ~this.aggregation.enabled + 2} />
        </div>
      )
    }

    return (
      <div>
        <SelectInput
          label={'Aggregation Method'}
          fields={{ label: 'description', value: 'id' }}
          options={aggregationStore.aggregationMethods}
          onChange={this.onChangeAggregationMethod}
          value={this.aggregation.aggregation_method_id}
        />
        <SelectInput
          label={'Aggregation type'}
          value={this.aggregation.aggregation_type}
          fields={{ label: 'name', value: 'value' }}
          options={[
            { name: 'Left Closed Right Open', value: 1 },
            { name: 'Left Open Right Closed', value: 2 },
          ]}
          onChange={this.onChangeAggregationType}
        />
        <SelectInput
          label={'Aggregation Interval'}
          fields={{ label: 'name', value: 'id' }}
          options={aggregationStore.intervals}
          onChange={this.onChangeAggregationInterval}
          value={this.aggregation.interval_id}
        />
        <SelectInput
          label={'Source Data Series'}
          fields={{ label: 'name', value: 'id' }}
          options={this.dataSeriesItems}
          value={this.aggregation.source_series_id}
          onChange={this.onChangeSourceDataSeries}
        />
        <IntervalInput label='Time Offset' value={this.aggregation.time_offset} onChange={this.onChangeTimeOffset} />
        <TextInput label='Maximum Consecutive Missing Values' value={this.aggregation.max_cons_missing_values} onChange={this.onChangeMaxConsMissingValues} />
        <TextInput label='Maximum Missing Values' value={this.aggregation.max_missing_values} onChange={this.onChangeMaxMissingValues} />
        <DateInput label='Datetime' type='datetime-local' value={this.aggregation.timestamp} onChange={this.onChangeTimestamp} />
        <SwitchInput label='Use Suspicious' value={!!this.aggregation.use_suspicious} onChange={this.onChangeUseSuspicious} />
        <SwitchInput label='Enable Automatic' value={!!this.aggregation.enabled} onChange={() => this.aggregation.enabled = ~this.aggregation.enabled + 2} />
      </div>
    )
  };

  renderFields = () => {
    const { parameterStore, unitStore } = this.props;

    return (
      <div>
        <TextInput label={'Series Name'} value={this.stationDataSeries.name} onChange={this.onChangeName} />
        <SelectInput
          label={'Parameter'}
          fields={{ label: 'name', value: 'id' }}
          options={this.parameterItems}
          onChange={this.onChangeParameter}
          value={this.stationDataSeries.parameter_id}
          filterOptions={parameterStore.filterParameters}
        />
        <TextInput label={'Parameter ID'} value={this.stationDataSeries.parameter_id} readOnly />
        <TextInput label={'System Parameter Code'} value={this.stationDataSeries.parameter && this.stationDataSeries.parameter.code} readOnly />
        <SelectInput
          label={'Unit'}
          fields={{ label: 'name', value: 'id' }}
          options={unitStore.items}
          value={this.stationDataSeries.parameter_unit_id}
          onChange={this.onChangeUnit}
        />
        <TextInput label={'Description'} value={this.stationDataSeries.parameter && this.stationDataSeries.parameter.description} readOnly />
        <IntervalInput label='Interval' value={this.stationDataSeries.interval} onChange={e => this.stationDataSeries.interval = e.target.value} inMinutes />
        <TextInput label={'Start Time'} value={this.stationDataSeries.start_time} onChange={this.onChangeStartTime} />
        <TextInput label={'Tolerance'} value={this.stationDataSeries.tolerance} onChange={this.onChangeTolerance} />
        <SelectInput
          label={'Data Type'}
          fields={{ label: 'name', value: 'id' }}
          options={this.dataSearchTable}
          value={this.stationDataSeries.table}
          onChange={this.onChangeTable}
        />
      </div>
    )
  }

  render() {
    return (
      <Modal title={this.title} slug={this.slug}>
        {this.isLoading ? <Spinner /> : <div>
          {+this.stationDataSeries.table === 1 && <div className='TabBar TabBarRounded' style={{ marginTop: '10px' }}>
            <ul>
              <li className={this.tab === 0 ? 'active' : ''} onClick={() => this.tab = 0}><a>Series</a></li>
              <li className={this.tab === 1 ? 'active' : ''} onClick={() => this.tab = 1}><a>Aggregation</a></li>
            </ul>
          </div>}
          <Form>
            <FormBody>
              {+this.tab === 0 && this.renderFields()}
              {+this.stationDataSeries.table === 1 && +this.tab === 1 && this.renderAggregationFields()}
            </FormBody>
            <FormActions>
              <button onClick={this.handleSave}>Save</button>
            </FormActions>
          </Form>
        </div>}
      </Modal>
    );
  }
}


export default StationDataSeriesEdit;



// WEBPACK FOOTER //
// ./src/components/Station/DataSeries/StationDataSeriesEdit.js